import { twMerge } from "tailwind-merge";

export type DocumentStatus =
  | "PENDING"
  | "EXTRACTING_TEXT"
  | "GENERATING_CHUNKS"
  | "GENERATING_EMBEDDINGS"
  | "COMPLETED"
  | "FAILED";

interface InfohubDocumentStatusBadgeProps {
  status: DocumentStatus;
  className?: string;
}

const STATUS_CONFIG: Record<
  DocumentStatus,
  { label: string; color: string }
> = {
  PENDING: {
    label: "준비 중",
    color: "bg-gray-100 text-gray-700 border-gray-300",
  },
  EXTRACTING_TEXT: {
    label: "텍스트 추출",
    color: "bg-blue-100 text-blue-700 border-yellow-300",
  },
  GENERATING_CHUNKS: {
    label: "텍스트 분리",
    color: "bg-blue-100 text-blue-700 border-orange-300",
  },
  GENERATING_EMBEDDINGS: {
    label: "임베딩 생성",
    color: "bg-blue-100 text-blue-700 border-blue-300",
  },
  COMPLETED: {
    label: "처리 완료",
    color: "bg-green-100 text-green-700 border-green-300",
  },
  FAILED: {
    label: "처리 실패",
    color: "bg-red-100 text-red-700 border-red-300",
  },
};

function InfohubDocumentStatusBadge({
  status,
  className,
}: InfohubDocumentStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={twMerge(
        "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium",
        config.color,
        className
      )}
    >
      {config.label}
    </span>
  );
}

export default InfohubDocumentStatusBadge;
